import { render, staticRenderFns } from "./web-app.modal.vue?vue&type=template&id=63a2d525"
import script from "./web-app.modal.vue?vue&type=script&lang=ts"
export * from "./web-app.modal.vue?vue&type=script&lang=ts"
import style0 from "./web-app.modal.vue?vue&type=style&index=0&id=63a2d525&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports